export type TLiveTitleCurrencyCode = 'USD' | 'CNY';

interface ICurrencyResolveInput {
  unifiedId?: string;
  gameTitle?: string;
}

const DEFAULT_CURRENCY_CODE: TLiveTitleCurrencyCode = 'USD';

// Centralized currency rules for Live Titles.
// Prefer stable business keys (unified_id). Keep game_title as fallback for
// transitional data where unified_id is not yet fully standardized.
const CURRENCY_BY_UNIFIED_ID: Record<string, TLiveTitleCurrencyCode> = {
  // TODO: Replace with backend-stable unified_id once available.
};

const CURRENCY_BY_GAME_TITLE: Record<string, TLiveTitleCurrencyCode> = {
  'poe国服': 'CNY',
};

const normalizeCurrencyKey = (value?: string) => String(value || '').trim().toLowerCase();

export const resolveLiveTitleCurrencyCode = (
  input: ICurrencyResolveInput,
): TLiveTitleCurrencyCode => {
  const normalizedUnifiedId = normalizeCurrencyKey(input?.unifiedId);
  if (normalizedUnifiedId && CURRENCY_BY_UNIFIED_ID[normalizedUnifiedId]) {
    return CURRENCY_BY_UNIFIED_ID[normalizedUnifiedId];
  }

  const normalizedGameTitle = normalizeCurrencyKey(input?.gameTitle);
  if (normalizedGameTitle && CURRENCY_BY_GAME_TITLE[normalizedGameTitle]) {
    return CURRENCY_BY_GAME_TITLE[normalizedGameTitle];
  }

  return DEFAULT_CURRENCY_CODE;
};

export const getCurrencySymbol = (currencyCode: TLiveTitleCurrencyCode) => {
  return currencyCode === 'CNY' ? '¥' : '$';
};

export const mapUnitToCurrencyCode = (
  unit?: string,
): TLiveTitleCurrencyCode => {
  const normalizedUnit = normalizeCurrencyKey(unit);
  return normalizedUnit === 'rmb' || normalizedUnit === 'cny' ? 'CNY' : 'USD';
};

export const formatLiveTitleCurrencyText = (
  valueText: string,
  currencyCode: TLiveTitleCurrencyCode,
) => {
  return `${getCurrencySymbol(currencyCode)}${valueText}`;
};
